import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { delay } from 'rxjs/operators';
import { IPartnerConfig, PARTNER_CONFIG } from '@interticket/core';
import { IPartnerSource } from '@core/interfaces/partner/partner-source.interface';
import { IContact } from '@core/interfaces/contact/contact.interface';
import { CONTACTS } from '@core/mocks/contact/contact.mock';
import { IOnlinePartner } from '@core/interfaces/partner/online-partner.interface';
import { ONLINE_PARTNER_LIST } from '@core/mocks/partner/partner.mock';

@Injectable()
export class PartnerSourceMockService implements IPartnerSource {

  getConfig(): Observable<IPartnerConfig> {
    return of(PARTNER_CONFIG).pipe(delay(400));
  }

  getContacts(): Observable<IContact[]> {
    return of(CONTACTS).pipe(delay(300));
  }

  getOnlinePartnerList(): Observable<IOnlinePartner[]> {
    return of(ONLINE_PARTNER_LIST).pipe(delay(300));
  }

}
